import script from "./DynamicFormItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicFormItem.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicFormItem.vue?vue&type=style&index=0&id=efd1e46e&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd1e46e"]])

export default __exports__